import { useSelector } from 'react-redux';

import type { Node } from 'react';

type TProps = {
  children: Node,
  fallback?: ?Node
};

// Sometimes we need to make sure that we have done the initial server pull of
// DYOR selections on a page load before rendering a component. This is
// specifically true on the DYOR combo (step 3) product detail page, where we
// send the DYOR selections from the url (if present) to the server, changing
// the selections.

// Without this gate, we were sending the changes up before we pulled the data
// down, which was resulting in a weird staggered pattern depending on which
// request completed first. Each page refresh it would alternate between the two
// selections, until it eventually got it right (sometimes as many as five
// refreshes were needed).
function DYORServerSyncGate({ children, fallback }) {
  const synchronized = useSelector(
    state => state.ringBuilder.serverPullComplete
  );

  return synchronized ? children : fallback || null;
}

export default (props, railsContext) => (
  <DYORServerSyncGate {...{ ...props, railsContext }} />
);
